(function loadWillowCollectionActions() {
  const currentScript = document.currentScript;
  if (
    !currentScript ||
    window.__willowCollectionActions ||
    document.querySelector('script[data-willow-collection-actions]')
  ) return;

  const actionsScript = document.createElement('script');
  actionsScript.src = new URL('willow-collection-actions.js', currentScript.src).toString();
  actionsScript.async = false;
  actionsScript.dataset.willowCollectionActions = '';
  document.head.appendChild(actionsScript);
})();

if (!customElements.get('search-drawer')) {
  customElements.define(
    'search-drawer',
    class SearchDrawer extends DrawerElement {
      constructor() {
        super();
      }

      get shouldAppendToBody() {
        return false;
      }

      get input() {
        return this.querySelector('input[type="search"]');
      }

      get focusElement() {
        return this.querySelector('input[type="search"]');
      }
    }
  );
}

if (!customElements.get('search-typed')) {
  customElements.define(
    'search-typed',
    class SearchTyped extends HTMLElement {
      constructor() {
        super();

        Motion.inView(this, this.init.bind(this));
      }

      get startDelay() {
        return this.hasAttribute('data-delay') ? parseFloat(this.getAttribute('data-delay')) : 0;
      }

      async init() {
        this.insertCursor();
        await this.start(this.getAttribute('data-first-text'), this.startDelay);

        setTimeout(async () => {
          await this.reset();
          await this.start(this.getAttribute('data-last-text'), 0);
        }, 600);
      }

      async start(text, delay) {
        this.innerHTML = text;
        await Motion.animate(this, { width: [0, `${this.scrollWidth}px`] }, { duration: 1, delay }).finished;
        this.cursor.classList.add('blink');
      }

      async reset() {
        this.cursor.classList.remove('blink');
        await Motion.animate(this, { width: 0 }, { duration: 0.25 }).finished;
      }

      insertCursor() {
        if (this.cursor) return;

        this.cursor = document.createElement('span');
        this.cursor.className = 'typed-cursor';
        this.cursor.setAttribute('aria-hidden', true);
        this.cursor.innerHTML = '|';
        this.parentElement.insertBefore(this.cursor, this.nextSibling);
      }
    }
  );
}

const WILLOW_HIDDEN_PRODUCT_QUERY = '-tag:dont_show';
const WILLOW_HIDDEN_PRODUCT_PATTERN = /\s*-tag:(?:"dont_show"|dont_show)/gi;

if (!customElements.get('predictive-search')) {
  customElements.define(
    'predictive-search',
    class PredictiveSearch extends HTMLFormElement {
      constructor() {
        super();

        this.cachedMap = new Map();
        this.focusElement = this.input;

        this.resetButton.addEventListener('click', this.clear.bind(this));
        this.addEventListener('formdata', this.onFormData.bind(this));
        this.input.addEventListener('click', this.hideTypewriter.bind(this));
        this.input.addEventListener('input', theme.utils.debounce(this.onChange.bind(this), 300));
        this.input.addEventListener('focus', this.onFocus.bind(this));
      }

      get input() {
        return this.querySelector('input[type="search"]');
      }

      get resetButton() {
        return this.querySelector('button[type="reset"]');
      }

      get typewriter() {
        return this.input.previousElementSibling;
      }

      hideTypewriter() {
        if (this.typewriter && !this.typewriter.hasAttribute('hidden')) {
          this.typewriter.setAttribute('hidden', '');
        }
      }

      onFocus(event) {
        if (this.closest('.collection')) {
          document.body.classList.add('predictive-search-open');

          const searchTerm = this.getQuery();
          if (searchTerm.length === 0) return;

          const url = this.buildUrl().toString();
          this.renderSection(url, event);
        }
      }

      clear(event = null) {
        if (event) event.preventDefault();

        this.input.value = '';
        this.input.focus();
        this.removeAttribute('results');
      }

      cleanQuery(query) {
        return query
          .replace(WILLOW_HIDDEN_PRODUCT_PATTERN, ' ')
          .replace(/\btitle:/gi, '').replace(/\*/g, '')
          .replace(/\s+/g, ' ')
          .trim();
      }

      getQuery() {
        return this.cleanQuery(this.input.value);
      }

      getSearchQuery(rawQuery = this.input.value) {
        const query = this.cleanQuery(rawQuery);
        if (!query) return '';
        const isSku = /^[a-z0-9][a-z0-9_-]{2,}$/i.test(query) && /[_0-9-]/.test(query);
        if (isSku) return query;
        const sizeMatch = query.match(/(?:^|\s)(24|30|36|42|48|60|72|80|84|96)(?:\s*(?:in(?:ch(?:es)?)?\.?|[\"″]))?(?=\s|$)/i);
        if(sizeMatch) {
          const words=query.replace(sizeMatch[0],' ').replace(/[^a-z0-9 -]/gi,' ').trim().split(/\s+/).filter(Boolean);
          return `${WILLOW_HIDDEN_PRODUCT_QUERY} ${words.map(word => 'title:'+word).concat('title:'+sizeMatch[1]).join(' ')}`;
        }
        const prefixQuery = /^[a-z0-9\s-]+$/i.test(query)
          ? query.replace(/([a-z0-9]+)$/i, '$1*')
          : query;
        return `${WILLOW_HIDDEN_PRODUCT_QUERY} ${prefixQuery}`;
      }

      onFormData(event) {
        const query = this.getSearchQuery();
        if (query) event.formData.set('q', query);
        event.formData.set('type','product');
      }

      /* The predictive endpoint is not the search endpoint: it takes plain words and
         does not understand `-tag:dont_show`, so that filter reached it as two more
         words the product had to match, and the suggestions came back nearly empty.
         Send the shopper's words alone and let the snippet drop the hidden twins,
         which it already does. Ask for the API maximum so there is room left after
         they are dropped; the snippet still shows only data-limit of them. */
      buildUrl() {
        const url = new URL(`${theme.routes.shop_url}${theme.routes.predictive_search_url}`);

        url.searchParams.set('q', this.getQuery());
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor,variants.sku');
        url.searchParams.set('resources[limit]', 10);
        url.searchParams.set('resources[limit_scope]', 'each');
        url.searchParams.set('section_id', theme.utils.sectionId(this));
        return url;
      }

      onChange() {
        if (this.getQuery().length === 0) {
          this.clear();
          return;
        }

        this.hideTypewriter();

        const url = this.buildUrl().toString();
        this.renderSection(url);
      }

      renderSection(url) {
        this.cachedMap.has(url)
          ? this.renderSectionFromCache(url)
          : this.renderSectionFromFetch(url);
      }

      renderSectionFromCache(url) {
        const responseText = this.cachedMap.get(url);
        this.renderSearchResults(responseText);

        this.setAttribute('results', '');
      }

      renderSectionFromFetch(url) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        
        this.setAttribute('loading', '');

        fetch(url, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.renderSearchResults(responseText);
            this.cachedMap.set(url, responseText);

            this.removeAttribute('loading');
            this.setAttribute('results', '');
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            }
            else {
              console.error(error);
            }
          });
      }

      renderSearchResults(responseText) {
        const id = 'PredictiveSearchResults-' + theme.utils.sectionId(this);
        if (document.getElementById(id) === null) return;

        document.getElementById(id).innerHTML = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .getElementById(id)?.innerHTML || '';
      }
    }, { extends: 'form' }
  );
}

if (!customElements.get('predictive-search-overlay')) {
  customElements.define(
    'predictive-search-overlay',
    class PredictiveSearchOverlay extends OverlayElement {
      constructor() {
        super();

        this.addEventListener('click', this.onClick);
      }

      onClick() {
        setTimeout(() => {
          document.body.classList.remove('predictive-search-open');
        });
      }
    }
  );
}


(function(){
  function normalizeSearch(){
    if(!document.querySelector('.template-search')){
      if(!document.querySelector('.wv-search-refinements'))return;
    }
    var form=document.querySelector('form[is="predictive-search"]');
    var url=new URL(location.href);
    if(!form || typeof form.getSearchQuery!=='function' || !url.searchParams.has('q'))return;
    var raw=url.searchParams.get('q');
    var query=form.getSearchQuery(raw);
    if((/\btitle:\d+/.test(query) && query!==raw) || url.searchParams.get('type')!=='product'){
      url.searchParams.set('q',query);url.searchParams.set('type','product');url.searchParams.delete('page');location.replace(url.toString());
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',normalizeSearch);else normalizeSearch();
})();

(function () {
  if(!document.querySelector('.wv-search-refinements'))return;
  const fields={sizes:'filter.p.m.custom.vanity_width',model:'filter.p.m.custom.design_collection',finishes:'filter.p.m.custom.color_variant_information'};
  const cache=new Map();let generation=0;
  async function pageData(url,page){
    const request=new URL(url);request.searchParams.set('section_id','willow-search-counts');request.searchParams.set('page',page);
    const response=await fetch(request,{credentials:'same-origin'});if(!response.ok)throw new Error('Search counts unavailable');
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');const node=doc.querySelector('[data-wv-search-counts]');if(!node)throw new Error('Search counts unavailable');
    return JSON.parse(node.textContent);
  }
  async function results(url){
    const request=new URL(url);request.searchParams.delete('page');request.searchParams.delete('section_id');request.searchParams.sort();
    const key=request.toString();if(cache.has(key))return cache.get(key);
    const work=(async()=>{
      const first=await pageData(request,1),items=first.items||[];
      for(let i=2;i<=first.pages;i+=3){const pages=await Promise.all(Array.from({length:Math.min(3,first.pages-i+1)},(_,n)=>pageData(request,i+n)));pages.forEach(page=>items.push(...page.items));}
      const unique=[...new Map(items.map(item=>[item.id,item])).values()];
      if(unique.length!==first.total)throw new Error('Search results changed; refresh to update counts');
      return unique;
    })().catch(error=>{cache.delete(key);throw error;});
    cache.set(key,work);return work;
  }
  async function refresh(){
    const host=document.getElementById('WillowSearchRefinements');if(!host)return;
    const current=++generation;host.setAttribute('aria-busy','true');
    try{
      const items=await results(location.href);if(current!==generation||!host.isConnected)return;
      const groups=[{key:'sizes',label:'Size',values:new Map()},{key:'model',label:'Model',values:new Map()},{key:'finishes',label:'Color & finish',values:new Map()}];
      items.forEach(item=>groups.forEach(group=>{
        let values=group.key==='finishes'?(item.finishes||[]).map(finish=>({value:String(finish.id||'').startsWith('gid:')?String(finish.id):'gid://shopify/Metaobject/'+finish.id,label:finish.label})):group.key==='sizes'?(Array.isArray(item.sizes)?item.sizes:item.sizes?[item.sizes]:[]).map(size=>({value:size,label:size})):(item.model?[{value:item.model,label:item.model}]:[]);
        const seen=new Set();values.forEach(value=>{if(!value.label||seen.has(value.value))return;seen.add(value.value);const existing=group.values.get(value.value)||{...value,count:0};existing.count++;group.values.set(value.value,existing);});
      }));
      host.replaceChildren();
      document.querySelectorAll('[data-wv-native-count]').forEach(el=>{el.textContent='(0)';el.hidden=false;});
      groups.forEach(group=>{
        if(!group.values.size)return;
        const row=document.createElement('div');row.className='wv-search-refinements__group';const label=document.createElement('span');label.textContent=group.label;row.appendChild(label);
        const choices=document.createElement('div');choices.className='wv-search-refinements__choices';row.appendChild(choices);
        [...group.values.values()].sort((a,b)=>a.label.localeCompare(b.label,undefined,{numeric:true})).forEach(value=>{
          const url=new URL(location.href),param=fields[group.key],selected=url.searchParams.getAll(param),active=selected.includes(value.value);
          url.searchParams.delete('page');url.searchParams.delete(param);selected.filter(v=>v!==value.value).forEach(v=>url.searchParams.append(param,v));if(!active)url.searchParams.append(param,value.value);
          const link=document.createElement('a');link.href=url.pathname+url.search;if(active)link.setAttribute('aria-current','true');link.textContent=value.label+' ('+value.count+')';choices.appendChild(link);
        });host.appendChild(row);
        document.querySelectorAll('input[name="'+fields[group.key]+'"]').forEach(input=>{
          const value=group.values.get(input.value),count=value?.count||0,wrap=input.closest('li,magnet-element'),badge=wrap?.querySelector('[data-wv-native-count]');
          if(badge){badge.textContent='('+count+')';badge.hidden=false;}input.disabled=!input.checked&&count===0;
        });
      });
      const note=document.createElement('small');note.textContent='Counts show matches within the current results.';host.appendChild(note);host.removeAttribute('aria-busy');
    }catch(error){if(current!==generation||!host.isConnected)return;host.removeAttribute('aria-busy');const note=document.createElement('small');note.textContent='Counts are temporarily unavailable. Select a filter to view matching products.';host.appendChild(note);console.warn('[willow] '+error.message);}
  }
  if(window.theme?.pubsub)theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.facetUpdate,refresh);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh);else refresh();
})();
